import React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';
import Navbar from '../shared/Navbar';
import { RootState } from '../../store/rootReducer';
import RequestCalloutWidget from './RequestCalloutWidget';
import api from "../../store/api";
import { useHistory } from "react-router-dom";
import { Grid, Button, Theme, makeStyles, CircularProgress, AppBar, Toolbar, } from "@material-ui/core";
import { consts } from "../../common/consts";
import navBarLogo from "../../assets/images/navBarLogo.svg";
import RightHandMenu from ".././shared/RightHandMenu";
import LeftHandMenu from ".././shared/LeftHandMenu";
import { Fragment } from "react";
import MenuIcon from "@material-ui/icons/Menu";
interface IUserData {
  givenName: string;
  surName: string;
  email: string;
  role: string;
  IsAdmin: boolean;
  exp: number;
  location: string;
  ward: string;
}

interface IAuthState {
  isAuthenticated?: boolean;
  token: string | null;
  userName: string | null;
  data: IUserData | null;
  sessionExpired: boolean;
  vehicleSessionId: string | null;
  vehicleNumber: string | null;
}
interface IUserType {
  IsAdmin: boolean | false;
  SMADriver: boolean | false;
  CanViewDashBoard: boolean | false;
}
interface RequestCalloutPageProps extends IAppPropsWithRoute { };

const Navbars: React.FC<any> = (props): JSX.Element => {
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      display: 'flex',
      backgroundColor: '#0049a3',
      position: 'sticky',
      zIndex: 1297,
      width: '100%',
      maxWidth: '100%',
      top: 0,
      paddingTop: "59px",
      '& header': {
        boxShadow: "none",
      },
    },
    logo: {
      height: '100%',
      textAlign: "center",
      display: "flex",
      justifyContent: 'center',
      alignItems: 'center',
    },
    logoImg: {
      cursor: 'pointer',
      width: 236,
      [theme.breakpoints.only("xs")]: {
        width: "100%",
      },
    },
    navBarElements: {
      fontSize: '18'
    },
    toolbar: {
      padding: 0,
      height: 59,
    },
    leftHandMenu: {
      height: '100%',
      '& .MuiButton-root': {
        minWidth: 0,
        width: "auto",
        fontWeight: "400",
        '& .MuiButton-iconSizeMedium > *:first-child': {
          fontSize: "26px",
        },
      },
    },
    rightHandMenu: {
      height: '100%',
      display: "flex",
      justifyContent: "flex-end",
      alignItems: 'center',
      '& .MuiButton-root': {
        minWidth: 0,
        width: "auto",
        fontWeight: "400",
        '& .MuiSvgIcon-root': {
          height: "1.6em",
          width: "1.6em",
        },
      },
    },
    rightHandMenuButton: {
      color: '#fff',
    }
  }));

  const getPermissions = (authStore: IAuthState): IUserType => {
    const permissions: IUserType = {
      IsAdmin: authStore?.data?.IsAdmin || false,
      SMADriver: authStore?.data ? (authStore?.data?.role?.indexOf(consts.Permissions.SMADriver) >= 0 ? true : false) : false,
      CanViewDashBoard: authStore?.data?.role
        ?.split(",")
        ?.some((p) => p == consts.Permissions.ViewDashboard || p == consts.Permissions.SMAAdminPatientTransportDashboard)
        ? true
        : false,
    };
    return permissions;
  };
  const { authStore } = useSelector((state: RootState) => state);
  var checkrols = authStore.data?.role?.split(",")?.includes(consts.Permissions.ViewDashboard ||  consts.Permissions.SMAAdminPatientTransportDashboard
    || consts.Permissions.ManageCustomerVehicles || consts.Permissions.ViewSchedule
    || consts.Permissions.ViewCustomerTransferHistory || consts.Permissions.SMAViewSchedule || consts.Permissions.SMAAdminManageUsers
    || consts.Permissions.SMAAdminManageUserprofiles || consts.Permissions.ManageUsers || consts.Permissions.ViewPCR
    || consts.Permissions.SMASubmitPatientCareRecords || consts.Permissions.SubmitPatientCareRecord ||  consts.Permissions.SMAAdminViewSystemActivity 
    || consts.Permissions.SMAViewPatientCareRecords 
    );
  const classes = useStyles();
  const { navbarContent } = useSelector((state: RootState) => state.appState);
  const leftButtonContent =
    navbarContent != null && navbarContent.leftButtonName ? (
      <Fragment>
        {checkrols ?
        <LeftHandMenu />
        :null}
      </Fragment>
    ) : (
      <MenuIcon />
    );
  const userPermissions = getPermissions(authStore);

  const home = (): void => {
    window.location.replace("/");
  };

  return (
    <div className={classes.root}>
      <AppBar position="fixed" {...(props.noNavBarShadow ? { elevation: 0 } : {})}>
        <Toolbar className={classes.toolbar} variant="dense">
          <Grid container spacing={0} style={{ height: "100%", width: "100%" }}>
            {props.noLogo && props.humberMenu === null ? (
              <Grid xs={12} item>
                <div className={classes.rightHandMenu}>
                  <RightHandMenu />
                </div>
              </Grid>
            ) : (
              <>
                <Grid item xs={3} sm={4}>
                  <div className={classes.leftHandMenu}>
                    {props.humberMenu === null ? null : props.humberMenu || leftButtonContent}
                  </div>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <div className={classes.logo}>
                    {props.noLogo ? null : <img src={navBarLogo} onClick={home} className={`${classes.logoImg}`} alt="logo" />}
                  </div>
                </Grid>
                <Grid item xs={3} sm={4}>
                  <div className={classes.rightHandMenu}>
                    <RightHandMenu />
                  </div>
                </Grid>
              </>
            )}
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  );
}
const RequestCalloutPage: React.FC<RequestCalloutPageProps> = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { authStore } = useSelector((state: RootState) => state);
  const [loading, setLoading] = React.useState(false);
  const [showLogo, setShowLogo] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    dispatch(showNavbar(false));
    // Check for existing callout and navigate to callout details 
    // page if there any existing callout
    const checkForExistingCallout = async () => {
      try {
        const res = await api.checkForExistingCallout("", {
          locationId: authStore.data?.location,
          wardId: authStore.data?.ward ? authStore.data?.ward : null
        });
        const requestCalloutId = res?.requestCalloutId;
        if (requestCalloutId) {
          history.push(`/calloutrequested/${requestCalloutId}`);
        }
        else
          setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    checkForExistingCallout();
  }, [])

  return (
    <>
      {/* { !loading && <Navbar noLogo={true} noNavBarShadow={true} humberMenu={null} righButtonName={authStore.userName ?? ''} />} */}
      <Navbars noLogo={!showLogo} />
      {!loading && <RequestCalloutWidget setShowLogo={setShowLogo} />}
    </>
  );
}

export default withRouter(RequestCalloutPage);
